import React from "react";
import {Box} from '@material-ui/core';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import StopIcon from '@material-ui/icons/Stop';
import setDate from "../../utils/setDate";
import theme from "../../styles/theme";
import convertToCurrency from "../../utils/convertToCurrency";

const LeadsSearchTable = () => {
    return [
        {
            id: 'status',
            title: 'Status',
            enabled: true,
            data: (loanRequest) => (
                <>
                    {loanRequest.loanResult && (
                        <Box display="flex" alignItems="center">
                            {
                                loanRequest.loanResult.status === 'SOLD' ? (
                                    <AttachMoneyIcon style={{color: theme.palette.success.main}}/>
                                ) : (
                                    <MoneyOffIcon style={{color: theme.palette.error.main}}/>
                                )
                            }
                            <strong>- {loanRequest.loanResult.status}</strong>
                        </Box>
                    )}
                </>
            )
        },
        {
            id: 'affiiateStatus',
            title: 'Affiliate Status',
            enabled: true,
            data: (loanRequest) => (
                <>
                    {loanRequest.loanResponse ? loanRequest.loanResponse.status : 'N/A'}
                </>
            )
        },
        {
            id: 'redirected',
            title: 'Redirected',
            enabled: true,
            data: (loanRequest) => (
                <Box display="flex" justifyContent="center">
                    {loanRequest.loanRedirect.length ? (
                        <PlayArrowIcon fontSize="large" style={{color: theme.palette.success.main}}/>
                    ) : (
                        <StopIcon fontSize="large" style={{color: theme.palette.error.main}}/>
                    )}
                </Box>
            )
        },
        {
            id: 'created',
            title: 'Created',
            enabled: true,
            data: (loanRequest) => (
                <>
                    {setDate(loanRequest.createdAt)}
                </>
            )
        },
        {
            id: 'primary-email',
            title: 'Primary Email',
            enabled: true,
            data: (loanRequest) => (
                <>
                    {loanRequest.primaryEmail}
                </>
            )
        },
        {
            id: 'affiliate',
            title: 'Affiliate',
            enabled: true,
            data: (loanRequest) => (
                <>
                    {loanRequest.trafficSource.affiliate.name}
                </>
            )
        },
        {
            id: 'traffic-source',
            title: 'Traffic Source',
            enabled: true,
            data: (loanRequest) => (
                <>
                    {loanRequest.trafficSource.name} ({loanRequest.trafficSource.legacyPromoId})
                </>
            )
        },
        {
            id: 'min',
            title: 'Min',
            enabled: true,
            alignment: 'right',
            data: (loanRequest) => (
                <>
                    {loanRequest.minimumPrice !== null ? convertToCurrency(loanRequest.minimumPrice) : 'N/A'}
                </>
            )
        },
        {
            id: 'servicer',
            title: 'Servicer',
            enabled: true,
            data: (loanRequest) => (
                <>
                    {loanRequest.loanResult && loanRequest.loanResult.servicerId ? loanRequest.loanResult.servicerId : 'N/A'}
                </>
            )
        },
        {
            id: 'campaign',
            title: 'Campaign',
            enabled: true,
            data: (loanRequest) => (
                <>
                    {loanRequest.loanResult && loanRequest.loanResult.campaignId ? loanRequest.loanResult.campaignId : 'N/A'}
                </>
            )
        },
        {
            id: 'billed',
            title: 'Billed',
            enabled: true,
            alignment: 'right',
            data: (loanRequest) => (
                <>
                    {loanRequest.loanResult && loanRequest.loanResult.billed !== null ? convertToCurrency(loanRequest.loanResult.billed) : 'N/A'}
                </>
            )
        },
        {
            id: 'payout',
            title: 'Payout',
            enabled: true,
            alignment: 'right',
            data: (loanRequest) => (
                <>
                    {loanRequest.loanResult && loanRequest.loanResult.payout !== null ? convertToCurrency(loanRequest.loanResult.payout) : 'N/A'}
                </>
            )
        },
        {
            id: 'scores',
            title: 'Scores',
            enabled: true,
            data: (loanRequest) => (
                <>
                    {loanRequest.leadScores.length ? (
                        <>
                            {loanRequest.leadScores.map(item => (
                                <Box key={item.id} display="flex">
                                    <Box padding={theme.spacing(0, 1, 0, 0)}>
                                        Grade: <strong>{item.grade}</strong>
                                    </Box>
                                    <Box>
                                        Score: <strong>{item.score}</strong>
                                    </Box>
                                </Box>
                            ))}
                        </>
                    ) : ('N/A')
                    }
                </>
            )
        }
    ];
};

export default LeadsSearchTable;
